import {APIService} from '@/services/api.service';

export async function trackSource(source: string, location: string, userId: string): Promise<boolean> {
  try {
    await APIService.post(
      `tracking/source`,
      {},
      {
        params: {
          mode: process.env.VUE_APP_MODE,
          user_id: userId,
          utm_source: source,
          location,
        },
      },
      true,
    );
    return true;
  } catch (e) {
    return false;
  }
}
